export type ScorecardFilterRequestConjunction = 'And' | 'Or';

export interface IScorecardFilterOption {
  conjunction: ScorecardFilterRequestConjunction;
  value: IScorecardFilterCondition;
}

export interface IScorecardFilter {
  options: IScorecardFilterOption[];
}

export interface IScorecardFilterRequestOption {
  conjunction: ScorecardFilterRequestConjunction;
  value: IScorecardFilterCondition;
}

export interface IScorecardFilterRequest {
  options: IScorecardFilterRequestOption[];
}

export interface IScorecardFilterCondition {
  scorecardId?: string;
  result?: ScorecardFilterConditionResults;
  scoreValue?: number;
}

export enum ScorecardFilterConditionResults {
  isPass = 'IsPass',
  isFail = 'IsFail',
  isAutoFailed = 'IsAutoFail',
  isNotApplicable = 'IsNotApplicable',
  isError = 'IsError',
  isGreaterThan = 'IsGreaterThan',
  isEqualTo = 'IsEqualTo',
  isLessThan = 'IsLessThan'
}
